import React from 'react';

import {isSettingEnabled} from './setting-enabled';

const NoOp = () => undefined;

const ReservationList = ({
    showReservationList,
    reservations,
    remainingSpots,
    changeReservationFunction,
    allowReservationChanges

}) => {
    const buildReservationRow = (participant) => {
        const onClick = isSettingEnabled(allowReservationChanges) ?
            (e) => {
                e.preventDefault();
                changeReservationFunction(participant);
            }
            : NoOp;

        return (
            <li
                key={participant.attendeeId}
            >
                <a
                    href={`#${participant.attendeeId}`}
                    onClick={onClick}
                >
                    {participant.firstName} {participant.lastName}
                </a>
            </li>
        );
    };

    if (!isSettingEnabled(showReservationList)) {
        return null;
    }

    return (
        <div>
            <h6 className="hy-vee-red">{'Reservations:'}</h6>
            <p>{`You have ${remainingSpots} reservations remaining.`}</p>
            <ul className="reservation-list-container">
                {reservations.map(buildReservationRow)}
            </ul>
        </div>
    );
};

export default ReservationList;



// WEBPACK FOOTER //
// ./src/event/ReservationList.js